/* eslint-disable no-param-reassign */
// eslint-disable-next-line import/no-extraneous-dependencies
import { produce } from 'immer';

export default (
  set, get, partnerProductId = '325168962', productName, brand, logEventsToConsole, omnitureInfo,
  sendPaymentEstimatorImpressionToAnalytics, store, pageType
) => set(produce(get(), (draft) => {
  if (!draft.digitalData) {
    draft.digitalData = { event: [] };
  }

  draft.digitalData.configuratorPageLoad = {
    partnerProductId: partnerProductId || '325168962',
    productName,
    brand,
    logEventsToConsole,
    omnitureInfo,
    sendPaymentEstimatorImpressionToAnalytics,
    store,
    pageType
  };

}), false, { type: 'TRACK_PACKOUT_CUSTOM_CONFIGURATOR_PAGE_LOAD' });
